import Vue from "vue";
import _ from "lodash";

function initialState() {
  return {
    isFetching: false,
    loadingFailed: false,
    viewMode: 'admin',

    selectedBooth: null
  };
}

const state = {
  isFetching: initialState().isFetching,
  loadingFailed: initialState().loadingFailed,
  viewMode: initialState().viewMode,

  selectedBooth: initialState().selectedBooth,
};

const mutations = {
  SET_IS_FETCHING: (state, value) => {
    Vue.set(state, "isFetching", value);
  },
  SET_LOADING_FAILED: (state, val) => {
    Vue.set(state, "loadingFailed", val);
  },
  SET_VIEW_MODE: (state, val) => {
    Vue.set(state, "viewMode", val);
  },

  SELECT_BOOTH: (state, val) => {
    Vue.set(state, "selectedBooth", val);
  },
};

const actions = {};

const getters = {
  isFetching: state => state.isFetching,
  loadingFailed: state => state.loadingFailed
};

export default {
  state,
  mutations,
  actions,
  getters
};